import { setItem, getItem, removeItem, clearAll } from './browserStorage'

const getSessionStorage = () => {
  const { sessionStorage } = window || global

  return sessionStorage
}

export const add = (key: string, value: string): void => setItem(getSessionStorage(), key, value)

export const get = (key: string, defaultValue: string): string => getItem(getSessionStorage(), key, defaultValue)

export const remove = (key: string): void => removeItem(getSessionStorage(), key)

export const clear = (): void => clearAll(getSessionStorage())

export const Keys = {
  ORDER: 'order',
  BASKET: 'basket',
}
